module.exports = __webpack_public_path__ + "img-upsell-light.113ea8b9b1f6f03f420727e1e3bc301b.hashedasset.svg";